export default __webpack_public_path__ + "static/jazz-e460f73295b2a9594b66e428cd418bdc.jpg";